/*** topicSet 题组 ***/
import { http } from '@/api/http';

export default {
    getTopicSetList(data) {
        return http.get(`/api/Topic/TopicSet/List`, data);
    },
    getTopicSetDetail(id, data) {
        return http.get(`/api/Topic/TopicSet/${id}`, data);
    },
    postTopicSet(data) {
        return http.post(`/api/Topic/TopicSet`, data);
    },
    editTopicSet(id, data) {
        return http.put(`/api/Topic/TopicSet/Info/${id}`, data);
    },
    deleteTopicSet(id) {
        return http.delete(`/api/Topic/TopicSet/${id}`)
    },
    publishTopicSet(id, isPublish) {
        let action = isPublish ? 'Publish': 'Unpublish'
        return http.put(`/api/Topic/TopicSet/${action}/${id}`);
    },
    getTopicSetTopicList(data) {
        return http.get(`/api/Topic/QueryByTopicSet`, data);
    },
    // 题组中已选择的题目id array
    getTopicSetTopicIds(id) {
        return http.get(`/api/Topic/${id}/TopicIds`);
    },
    editTopicSetTopics(id, data) {
        return http.put(`/api/Topic/TopicSet/${id}`, data, {contentType: 'form'});
    },

    // 每日一练排名
    getDailyStudyRank(data) {
        return http.get(`/api/DailyIStudy/Rank`, data);
    }
}
